import script from "./Testimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonial.vue?vue&type=script&setup=true&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=bd45a358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd45a358"]])

export default __exports__